import * as React from "react";

import { Icon, IconProps } from "./icon";
import { ReactComponent as MailIcon } from "./mail.svg";

const IconMail = ({ width = "23px", height = "17px" }: IconProps) => (
  <Icon src={MailIcon} width={width} height={height} />
);
export { IconMail };
